// Which build is live, and whether this phone is running an older one.
//
// The driver app never reloads itself: an installed PWA resumed from the
// background keeps running the code it loaded, possibly all day, and a stamp
// made on an old build silently lacks whatever the new one writes (v1.54.0's
// delivered time to SAP was the case that showed it). The build writes
// version.json beside index.html (vue.config.js); the driver bar fetches it and
// offers a reload. It OFFERS, never forces -- a reload in the middle of a photo
// sheet would lose the photos.
//
// Compared by build stamp, not by version number: a rebuild that forgot to bump
// the version is still a different build, and so is a rollback.
//
// Pure apart from fetchLiveVersion; covered by npm run test:driver.

const CHECK_GAP_MS = 5 * 60000

// The build this page was loaded from. Empty on the dev server, which never
// asks (vue.config.js sets these for every build, but `serve` rebuilds live).
const CURRENT = {
  version: process.env.VUE_APP_VERSION || '',
  build: process.env.NODE_ENV === 'production' ? (process.env.VUE_APP_BUILD || '') : ''
}

// version.json as an object, or null. The SPA rewrite answers a missing file
// with index.html at HTTP 200, so an unreadable body is "no version", not an error.
function readVersionFile (body) {
  let v = body
  if (typeof v === 'string') {
    try { v = JSON.parse(v) } catch (e) { return null }
  }
  if (!v || typeof v !== 'object' || typeof v.build !== 'string' || !v.build) return null
  return { version: typeof v.version === 'string' ? v.version : '', build: v.build }
}

function updateAvailable (currentBuild, live) {
  if (!currentBuild || !live) return false
  return live.build !== currentBuild
}

function checkDue (lastCheckedAt, now) {
  return !lastCheckedAt || now - lastCheckedAt >= CHECK_GAP_MS
}

function versionLabel (version) {
  return version ? 'v' + version : 'ไม่ทราบเวอร์ชัน'
}

// Relative, so it resolves beside index.html on both hosts (/delivery/ on IIS,
// / on Firebase Hosting). The query string and no-store step past Hosting's
// one-hour Cache-Control. Never throws: a failed check just means no offer.
async function fetchLiveVersion () {
  try {
    const res = await fetch('./version.json?t=' + Date.now(), { cache: 'no-store' })
    if (!res.ok) return null
    return readVersionFile(await res.text())
  } catch (e) {
    return null
  }
}

module.exports = { CHECK_GAP_MS, CURRENT, readVersionFile, updateAvailable, checkDue, versionLabel, fetchLiveVersion }
